"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Calls a specific handler function for all events that are encountered.
 *
 * @param func — The function to multiplex all events to.
 */

var MultiplexHandler =
/** @class */
function () {
  function MultiplexHandler(func) {
    this._func = func;
  }
  /* Format: eventname: number of arguments */


  MultiplexHandler.prototype.onattribute = function (name, value) {
    this._func("onattribute", name, value);
  };

  MultiplexHandler.prototype.oncdatastart = function () {
    this._func("oncdatastart");
  };

  MultiplexHandler.prototype.oncdataend = function () {
    this._func("oncdataend");
  };

  MultiplexHandler.prototype.ontext = function (text) {
    this._func("ontext", text);
  };

  MultiplexHandler.prototype.onprocessinginstruction = function (name, value) {
    this._func("onprocessinginstruction", name, value);
  };

  MultiplexHandler.prototype.oncomment = function (comment) {
    this._func("oncomment", comment);
  };

  MultiplexHandler.prototype.oncommentend = function () {
    this._func("oncommentend");
  };

  MultiplexHandler.prototype.onclosetag = function (name) {
    this._func("onclosetag", name);
  };

  MultiplexHandler.prototype.onopentag = function (name, attribs) {
    this._func("onopentag", name, attribs);
  };

  MultiplexHandler.prototype.onopentagname = function (name) {
    this._func("onopentagname", name);
  };

  MultiplexHandler.prototype.onerror = function (error) {
    this._func("onerror", error);
  };

  MultiplexHandler.prototype.onend = function () {
    this._func("onend");
  };

  MultiplexHandler.prototype.onparserinit = function (parser) {
    this._func("onparserinit", parser);
  };

  MultiplexHandler.prototype.onreset = function () {
    this._func("onreset");
  };

  return MultiplexHandler;
}();

exports.default = MultiplexHandler;